import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { useEffect,useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import CommonTable from "../../../components/comman/CommonTable";
const PendingBudgetRequests = ({ siteId }) => {
  const navigate = useNavigate();
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    budgetRequestList: [],
  });

  useEffect(() => {
      GetBudgetRequestList();
  }, [siteId]);

  const GetBudgetRequestList = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_site_budget_request +
      `pageNumber=1&pageSize=5&status=pending${siteId ? `&siteId=${siteId}`: ""}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      BudgetRequestData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.budgetRequest?.map((item) => ({
          ...item,
          poNumber: item?.purchase?.purchaseNumber,
          siteName: item?.purchase?.purchaserequest?.site?.name,
          siteType: item?.purchase?.purchaserequest?.site?.type,
          requestedBy: item?.user?.name,
          budgetStatus: item?.status,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          budgetRequestList: newData,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "poNumber", label: "PO No." },
    { value: "siteName", label: "Site" },
    { value: "siteType", label: "Site Type" },
    { value: "requestedBy", label: "Requested By" },
    { value: "budgetStatus", label: "Status" },
  ];

  return (
    <div className="col-6 col-lg-6">
      <div className="card height-full">
        <div className="card-body">
          <div className="card-head">
            <h3 className="card-title">Pending Budget Requests</h3>

            <button
              type="button"
              className="btn btn-outline-primary py-1"
              onClick={() => navigate(RoutesLink?.budget_requests)}
            >
              View All
            </button>
          </div>
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates?.budgetRequestList}
            isLoading={pageStates?.tableLoader}
          />
        </div>
      </div>
    </div>
  );
};

export default PendingBudgetRequests;
